export const dropdownDirective = {
    name: 'dropdown',
    arg: {
        type: 'myst',
    },
    options: {
        open: {
            type: Boolean,
        },
        // Legacy options we may want to implement:
        // color
        // icon
        // animate
        // margin
        // name
        // 'class-container'
        // 'class-title'
        // 'class-body'
    },
    body: {
        type: 'myst',
        required: true,
    },
    run(data) {
        var _a;
        const children = [];
        if (data.arg) {
            children.push({ type: 'summary', children: data.arg });
        }
        children.push(...data.body);
        return [
            {
                type: 'details',
                open: (_a = data.options) === null || _a === void 0 ? void 0 : _a.open,
                children,
            },
        ];
    },
};
